import { Button } from '@eucalyptusvc/design-system';
import { useAuth } from '@customer-frontend/auth';

import type { LogoutButtonProps } from './types';

export const LogoutButton = ({
  level,
  palette,
  isFullWidth,
}: LogoutButtonProps): JSX.Element => {
  const { logout } = useAuth();

  return (
    <Button
      level={level}
      palette={palette}
      isFullWidth={isFullWidth}
      onClick={logout}
    >
      Log out
    </Button>
  );
};
